// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import CreditCheckActionType from './credit-check.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Credit Check Member Add Response
	creditCheckMemberAddResponse: null,
	// Credit Check Member Add Response List
	creditCheckMemberAddResponseList: [],
	// Credit Check Call Response
	creditCheckCallResponse: null,
	// Credit Check Call Array
	creditCheckCallArr: [],
	// Equifax Check Call Response
	equifaxCheckCallResponse: null,
	// Equifax Check Call Array
	equifaxCheckCallArr: [],
	// Verify Member Response
	verifyMemberResp: null,
	// Verify Member Data
	verifyMemberData: [],
	// Send Verify OTP Response
	sendVerifyOtpResponse: null,
	// Verify Credit Check Aadhar OTP Response
	verifyCreditCheckAadharOtpResp: null,
	// Verify Credit Check Aadhar OTP Result
	verifyCreditCheckAadharOtpResult: [],
	// Verify Validate Credit Check Aadhar OTP Response
	verifyValidateCreditCheckAadharOtpResp: null,
	// Verify Validate Credit Check Aadhar OTP Result
	verifyValidateCreditCheckAadharOtpResult: [],
	// Recheck Member Details CRIF Response
	recheckMemberDetailsCrifResp: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD CREDIT CHECK MEMBER START *********************** */
		case CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_SUCCESS:
			return {
				...state,
				creditCheckMemberAddResponse: action.payload,
				creditCheckMemberAddResponseList: docodeHexResponse(
					action.payload,
					'AddMemberCreditCheckMember',
				),
			};

		case CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_FAILURE:
			return { ...state, creditCheckMemberAddResponse: action.payload };

		case CreditCheckActionType.CREDIT_CHECK_MEMBER_ADD_RESPONSE_CHANGED:
			return { ...state, creditCheckMemberAddResponse: null };
		/** ***************** ADD CREDIT CHECK MEMBER END *********************** */

		/** ***************** HIGHMARK CREDIT CHECK CALL START *********************** */
		case CreditCheckActionType.CREDIT_CHECK_CALL_SUCCESS:
			return {
				...state,
				creditCheckCallResponse: action.payload,
				creditCheckCallArr: docodeHexResponse(action.payload, 'CallHighMarkDetailsKey'),
			};

		case CreditCheckActionType.CREDIT_CHECK_CALL_FAILURE:
			return { ...state, creditCheckCallResponse: action.payload };

		case CreditCheckActionType.CREDIT_CHECK_CALL_RESPONSE_CHANGED:
			return { ...state, creditCheckCallResponse: null };
		/** ***************** HIGHMARK CREDIT CHECK CALL END *********************** */

		/** ***************** EQUIFAX CREDIT CHECK CALL START *********************** */
		case CreditCheckActionType.EQUIFAX_CHECK_CALL_SUCCESS:
			return {
				...state,
				equifaxCheckCallResponse: action.payload,
				equifaxCheckCallArr: docodeHexResponse(action.payload, 'AppCheckEquifaxKey'),
			};

		case CreditCheckActionType.EQUIFAX_CHECK_CALL_FAILURE:
			return { ...state, equifaxCheckCallResponse: action.payload };

		case CreditCheckActionType.EQUIFAX_CHECK_CALL_RESPONSE_CHANGED:
			return { ...state, equifaxCheckCallResponse: null };
		/** ***************** EQUIFAX CREDIT CHECK CALL END *********************** */

		/** ***************** VERIFY MEMBER START *********************** */
		case CreditCheckActionType.VERIFY_MEMBER_SUCCESS:
			return { ...state, verifyMemberResp: action.payload };

		case CreditCheckActionType.VERIFY_MEMBER_FAILURE:
			return { ...state, verifyMemberResp: action.payload };

		case CreditCheckActionType.VERIFY_MEMBER_RESPONSE_CHANGED:
			return { ...state, verifyMemberResp: null };
		/** ***************** VERIFY MEMBER END *********************** */

		/** ***************** SEND VERIFICATION OTP START *********************** */
		case CreditCheckActionType.SEND_VERIFICATION_OTP_SUCCESS:
			return { ...state, sendVerifyOtpResponse: action.payload };

		case CreditCheckActionType.SEND_VERIFICATION_OTP_FAILURE:
			return { ...state, sendVerifyOtpResponse: action.payload };

		case CreditCheckActionType.SEND_VERIFICATION_OTP_RESPONSE_CHANGED:
			return { ...state, sendVerifyOtpResponse: null };
		/** ***************** SEND VERIFICATION OTP END *********************** */

		/** ***************** VERIFY CREDIT CHECK AADHAR OTP START *********************** */
		case CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_SUCCESS:
			return {
				...state,
				verifyCreditCheckAadharOtpResp: action.payload,
				verifyCreditCheckAadharOtpResult: docodeHexResponse(
					action.payload,
					'AppVerifyKYCKey',
				),
			};

		case CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_FAILURE:
			return { ...state, verifyCreditCheckAadharOtpResp: action.payload };

		case CreditCheckActionType.VERIFY_CREDIT_CHECK_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, verifyCreditCheckAadharOtpResp: null };
		/** ***************** VERIFY CREDIT CHECK AADHAR OTP END *********************** */

		/** ***************** VALIDATE CREDIT CHECK AADHAR OTP START *********************** */
		case CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_SUCCESS:
			return {
				...state,
				verifyValidateCreditCheckAadharOtpResp: action.payload,
				verifyValidateCreditCheckAadharOtpResult: docodeHexResponse(
					action.payload,
					'AppVerifyKYCKey',
				),
			};

		case CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_FAILURE:
			return { ...state, verifyValidateCreditCheckAadharOtpResp: action.payload };

		case CreditCheckActionType.VERIFY_VALIDATE_CREDIT_CHECK_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, verifyValidateCreditCheckAadharOtpResp: null };
		/** ***************** VALIDATE CREDIT CHECK AADHAR OTP END *********************** */

		/** ***************** RECHECK MEMBER DETAILS FOR CRIF START *********************** */
		case CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_SUCCESS:
			return { ...state, recheckMemberDetailsCrifResp: action.payload };

		case CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_FAILURE:
			return { ...state, recheckMemberDetailsCrifResp: action.payload };

		case CreditCheckActionType.RECHECK_MEMBER_DETAILS_FOR_CRIF_RESPONSE_CHANGED:
			return { ...state, recheckMemberDetailsCrifResp: null };
		/** ***************** RECHECK MEMBER DETAILS FOR CRIF END *********************** */
		default:
			return state;
	}
};
